import i18n from "i18n";

const Messages = {
  Create: i18n.t('notifications.common.create', { dataType: i18n.t('labels.template') }),
  Update: i18n.t('notifications.common.update', { dataType: i18n.t('labels.template') }),
  Delete: i18n.t('notifications.common.delete', { dataType: i18n.t('labels.template') })
};

export default Messages;

i18n.on('languageChanged', () => {
  Messages.Create = i18n.t('notifications.common.create', { dataType: i18n.t('labels.template') });
  Messages.Update = i18n.t('notifications.common.update', { dataType: i18n.t('labels.template') });
  Messages.Delete = i18n.t('notifications.common.delete', { dataType: i18n.t('labels.template') })
});